import React, { Suspense } from 'react';
import Loader from '../../../components/commons/helpers/loader/loader.component';

function NewConsultingCategoryLandingPage({
  page: { MainContent, breadCrumbList },
  section,
}) {
  const HeroComponent = React.lazy(() =>
    import('./new-consulting-category-hero-component')
  );
  const ContentComponent = React.lazy(() =>
    import('./new-consulting-category-content')
  );

  return (
    <div className={`consulting consulting-category ${section || ''}`}>
      <Suspense fallback={<Loader />}>
        <HeroComponent
          MainContent={MainContent}
          section={section}
          breadCrumbList={breadCrumbList}
        />
      </Suspense>
      <Suspense fallback={<Loader />}>
        <ContentComponent section={section} />
      </Suspense>
    </div>
  );
}

export default NewConsultingCategoryLandingPage;
